var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M40.07,0a40.07,40.07,0,0,0,0,80.14c22.1,0,40.07-14.84,40.07-40.07A40.11,40.11,0,0,0,40.07,0Zm0,72.69A32.62,32.62,0,1,1,72.69,40.07,32.66,32.66,0,0,1,40.07,72.69Z","fill":"#2a2d58","key":1}),React.createElement("path",{"d":"M44.84,21.17h0a3.89,3.89,0,0,0-3.73,4L41,40.55l-18.89-.07a4,4,0,0,0,0,8l22.29.08a3.36,3.36,0,0,0,1.45-.32,3.92,3.92,0,0,0,2.61-3.76l.08-19.31A3.89,3.89,0,0,0,44.84,21.17Z","fill":"#f1b860","key":2})]);
}

Time.defaultProps = {"viewBox":"0 0 80.14 80.14"};

module.exports = Time;

Time.default = Time;
